import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { StaticContentWidget } from 'embedded-academy-lib';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { useRef, useState } from 'react';
import { useCurrentVideoTime } from '../../video/components/VideoPlayerWithControls';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { CopyTextArea } from 'foundations-components/transitional/components/CopyTextArea';
import { useEmbedState } from '../embedStore';
import { Link } from 'foundations-components/transitional/components/Link';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ReactEmbedView = ({
  lessonId,
  contentId,
  shortId,
  language
}) => {
  const {
    currentVideoTime
  } = useCurrentVideoTime();
  const {
    current: videoTimeWhenModalWasOpened
  } = useRef(Math.round(currentVideoTime));
  const {
    iframeName,
    variant,
    authType,
    setIframeName,
    setVariant,
    setAuthType
  } = useEmbedState();
  const [startAtTimeSelected, setStartAtTimeSelected] = useState(false);
  const [startAtTime, setStartAtTime] = useState();
  const startTime = startAtTimeSelected ? startAtTime || videoTimeWhenModalWasOpened : 0;
  return /*#__PURE__*/_jsxs(View, {
    textAlign: "start",
    children: [/*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(IconHolder, {
        icon: InfoIcon,
        marginInlineStart: "-200"
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.embedModal.react.description"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "small",
        display: "block",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.embedModal.react.formParametersHelp"
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(StaticContentWidget, {
        authType: authType,
        contentId: contentId,
        language: language,
        lessonId: lessonId,
        name: iframeName,
        shortId: shortId,
        startTime: startTime.toString(),
        variant: variant
      })
    }), /*#__PURE__*/_jsxs(CardWrapper, {
      padding: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.embedModal.react.editParametersHeading"
        })
      }), /*#__PURE__*/_jsxs(View, {
        marginBlockEnd: "200",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          htmlFor: "name",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.react.iframeNameLabel"
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "200",
          typography: "heading-25",
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.react.iframeNameHelp"
          })
        }), /*#__PURE__*/_jsx(TextInput, {
          id: "name",
          onChange: e => setIframeName(e.target.value),
          value: iframeName
        })]
      }), /*#__PURE__*/_jsxs(View, {
        marginBlockEnd: "200",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          htmlFor: "variant",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.react.variantLabel"
          })
        }), /*#__PURE__*/_jsxs(ToggleGroup, {
          name: "variant",
          children: [/*#__PURE__*/_jsx(RadioInput, {
            checked: variant === 'default',
            onChange: e => setVariant(e.target.value),
            value: "default",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.embedModal.react.variantDefault"
            })
          }), /*#__PURE__*/_jsx(RadioInput, {
            checked: variant === 'video',
            onChange: e => setVariant(e.target.value),
            value: "video",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.embedModal.react.variantVideo"
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(View, {
        marginBlockEnd: "200",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          htmlFor: "startTime",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.startTimeCheckbox"
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "200",
          typography: "heading-25",
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.startTimeHelp"
          })
        }), /*#__PURE__*/_jsx(Checkbox, {
          checked: startAtTimeSelected,
          marginBlockEnd: "200",
          onChange: e => setStartAtTimeSelected(e.target.checked),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.startTimeCheckbox"
          })
        }), /*#__PURE__*/_jsx(NumberInput, {
          disabled: !startAtTimeSelected,
          id: "startTime",
          onChange: e => {
            setStartAtTime(+e.target.value);
          },
          value: startAtTime || videoTimeWhenModalWasOpened
        })]
      }), /*#__PURE__*/_jsxs(View, {
        marginBlockEnd: "200",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          htmlFor: "authType",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.react.authTypeLabel"
          })
        }), /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "200",
          typography: "heading-25",
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.embedModal.react.authTypeHelp"
          })
        }), /*#__PURE__*/_jsxs(ToggleGroup, {
          id: "authType",
          name: "authType",
          children: [/*#__PURE__*/_jsx(RadioInput, {
            checked: authType === 'app',
            onChange: e => setAuthType(e.target.value),
            value: "app",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.embedModal.react.authTypeApp"
            })
          }), /*#__PURE__*/_jsx(RadioInput, {
            checked: authType === 'public',
            onChange: e => setAuthType(e.target.value),
            value: "public",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.embedModal.react.authTypePublic"
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "200",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h6",
        marginBlock: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.embedModal.react.componentImportHeading"
        })
      }), /*#__PURE__*/_jsx(CopyTextArea, {
        buttonUse: "tertiary",
        value: `import { StaticContentWidget } from 'embedded-academy-lib';`
      }), /*#__PURE__*/_jsx(Text, {
        as: "h6",
        marginBlock: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.embedModal.react.generatedCodeHeading"
        })
      }), /*#__PURE__*/_jsx(CopyTextArea, {
        buttonUse: "primary",
        use: "code",
        value: `<StaticContentWidget
  ${[authType && authType !== 'app' && `authType="${authType}"`, iframeName && `name="${iframeName}"`, variant && variant !== 'default' && `variant="${variant}"`, contentId && `contentId={${contentId}}`, language && `language="${language}"`, lessonId && `lessonId={${lessonId}}`, shortId && `shortId={${shortId}}`, startTime && `startTime="${startTime}"`].filter(Boolean).join('\n  ')}
/>`
      })]
    }), /*#__PURE__*/_jsxs(Text, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.embedModal.react.moreInfoText"
      }), ' ', /*#__PURE__*/_jsx(Link, {
        external: true,
        href: `${getFullUrl('app', {
          envOverride: 'qa'
        })}/portal-recommend/l?slug=academy-playground/embedded-academy/static`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.embedModal.react.playgroundLink"
        })
      }), "."]
    })]
  });
};
export default ReactEmbedView;